import { LucideProps } from 'lucide-react';

/**
 * Dashed-line swatch for an image legend — the watercourse mark on the
 * Killwangen flood map (WB-845). See LegendBoxIcon for why the stroke colour is
 * hard-coded rather than taken from the brand palette.
 */
export const LegendLineIcon = ({
  size = 20,
  className,
  ...props
}: LucideProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    className={className}
    {...props}
  >
    <line
      x1="0"
      y1="10"
      x2="20"
      y2="10"
      stroke="#3E9BE0"
      strokeWidth="2"
      strokeDasharray="4 3"
    />
  </svg>
);
